import * as React from 'react';
import { getText } from '../../../../../services/text/text-service';
import useMobile from '../../../../../hooks/useMobile';
import { renderDropdown } from '../../../../../utils/formUtils';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { numberWithSpaces } from '../../../../../utils/stringUtils';
import { Title } from '@gje/typography/lib';

interface SelfContributionPanelProps {
    handleDeductibleCodeChange: Function;
    price: number;
    paymentTerm: number;
}

interface StateToProps {
    templateData: any;
}

const renderSelfContribution = templateData => {
    return templateData.workSelfrisk
        .map(option => ({
            item: `${numberWithSpaces(option.name)} kr`,
            value: option.value
        }))
        .sort((a, b) => {
            return a.value - b.value;
        });
};

const SelfContributionPanel: React.FC<
    SelfContributionPanelProps & StateToProps
> = ({ handleDeductibleCodeChange, templateData }) => {
    const isMobile = useMobile();

    return (
        <>
            {isMobile ? (
                <div className="row plus-package mobile-padding">
                    <div className="row">
                        <div className="col-xs-23 text-center">
                            <Field
                                name="deductibleCode"
                                data={{
                                    label: getText(
                                        'webshopsweden.products.employeeHealthcare.selfContributionChoose'
                                    ),
                                    helpText: getText(
                                        'webshopsweden.products.employeeHealthcare.selfContributionChoose.helpText'
                                    ),
                                    options: renderSelfContribution(
                                        templateData
                                    ),
                                    onChange: handleDeductibleCodeChange,
                                    defaultValue: templateData.workSelfrisk.find(
                                        el => el.default
                                    ).value
                                }}
                                component={renderDropdown}
                            />
                        </div>
                    </div>
                </div>
            ) : (
                <div className="row align-items-start insurance-amount">
                    <div className="col-sm-1-5" />
                    <div className="col-sm-20 align-left">
                        <Title
                            tag="h4"
                            className={'padding-left-6-5 margin-bottom-13'}>
                            {getText(
                                'webshopsweden.products.employeeHealthcare.selfContributionChoose'
                            )}
                        </Title>
                        <Field
                            name="deductibleCode"
                            data={{
                                helpText: getText(
                                    'webshopsweden.products.employeeHealthcare.selfContributionChoose.helpText'
                                ),
                                options: renderSelfContribution(templateData),
                                columnSize: '23',
                                wrapperClassName: 'no-margin-bottom',
                                onChange: handleDeductibleCodeChange,
                                defaultValue: templateData.workSelfrisk.find(
                                    el => el.default
                                ).value,
                                selectClassName: 'font-size-20'
                            }}
                            component={renderDropdown}
                        />
                    </div>
                    <div className="col-sm-1-5" />
                </div>
            )}
        </>
    );
};

const mapStateToProps = state => ({
    detailsPanelForm: state.form.detailsPanel,
    templateData: state.templateData.templateData
});

const Connected = connect<StateToProps, any, SelfContributionPanelProps>(
    mapStateToProps,
    {}
)(SelfContributionPanel);

export default reduxForm<StateToProps, any, SelfContributionPanelProps>({
    form: 'detailsPanel'
})(Connected);
